import * as React from "react";
import { forwardRef, memo } from "react";
const SvgStatusExecuted = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 1L6 12L1 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStatusExecuted);
const Memo = memo(ForwardRef);
export default Memo;
